import { useRef, useEffect, useCallback, useContext } from 'react'
import { useField } from '@unform/core'
import { UserContext } from 'context'

interface Props {
  name: string
  onChangeFile?: (_file?: File) => void
}
type InputProps = JSX.IntrinsicElements['input'] & Props

export default function ImageInput({
  name,
  onChangeFile,
  ...rest
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const { fieldName, registerField, error } = useField(name)
  const { setPreview, setPreview64 } = useContext(UserContext)
  const handlePreview = (e: any) => {
    const file: File = e.target.files?.[0]
    if (!file) setPreview('')
    onChangeFile && onChangeFile(file)
    const blobToBase64 = (blob: any, callback?: any) => {
      const reader = new FileReader()
      reader.onload = () => {
        const dataUrl: any = reader.result
        const base64 = dataUrl?.split(',')[1]
        callback(base64)
      }
      return reader.readAsDataURL(blob)
    }

    blobToBase64(file, setPreview64)

    const previewURL = URL.createObjectURL(file)
    setPreview(previewURL)
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'files[0]',
      clearValue(ref: HTMLInputElement) {
        ref.value = ''
        setPreview('')
      },
      setValue(_: HTMLInputElement, value: string) {
        setPreview(value)
      },
    })
  }, [fieldName, registerField])

  return (
    <input
      // style={error ? { borderWidth: 1, borderColor: '#f60665' } : {}}
      type="file"
      accept="image/png"
      ref={inputRef}
      onChange={handlePreview}
      {...rest}
    />
  )
}
